var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-week",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M3.375,12.375v33.75A3.375,3.375,0,0,0,6.75,49.5h40.5a3.375,3.375,0,0,0,3.375-3.375V12.375ZM6.75,2.25A6.75,6.75,0,0,0,0,9V46.125a6.75,6.75,0,0,0,6.75,6.75h40.5A6.75,6.75,0,0,0,54,46.125V9a6.75,6.75,0,0,0-6.75-6.75Z",
    transform: "translate(0 1.125)",
    fill: "#74613c",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M8.438,0a1.687,1.687,0,0,1,1.688,1.688V3.375a1.688,1.688,0,0,1-3.375,0V1.688A1.688,1.688,0,0,1,8.438,0ZM38.813,0A1.687,1.687,0,0,1,40.5,1.688V3.375a1.688,1.688,0,0,1-3.375,0V1.688A1.688,1.688,0,0,1,38.813,0Z",
    transform: "translate(3.375)",
    fill: "#74613c",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M33.75,15.188A1.688,1.688,0,0,1,35.438,13.5h3.375A1.687,1.687,0,0,1,40.5,15.188v3.375a1.687,1.687,0,0,1-1.687,1.688H35.438a1.688,1.688,0,0,1-1.687-1.687Zm-10.125,0A1.688,1.688,0,0,1,25.313,13.5h3.375a1.687,1.687,0,0,1,1.688,1.688v3.375a1.687,1.687,0,0,1-1.687,1.688H25.313a1.687,1.687,0,0,1-1.687-1.687ZM6.75,25.313a1.688,1.688,0,0,1,1.688-1.687h3.375A1.687,1.687,0,0,1,13.5,25.313v3.375a1.687,1.687,0,0,1-1.687,1.688H8.438A1.687,1.687,0,0,1,6.75,28.688Zm10.125,0a1.688,1.688,0,0,1,1.688-1.687h3.375a1.687,1.687,0,0,1,1.688,1.688v3.375a1.687,1.687,0,0,1-1.687,1.688H18.563a1.687,1.687,0,0,1-1.687-1.687Z",
    transform: "translate(3.375 6.75)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender2);
export default __webpack_public_path__ + "static/media/calender2.e6b58e2c72309df0aab2a226aacc6cd8.svg";
export { ForwardRef as ReactComponent };